// Discovery Session page (/discovery) — the fit-first framing a prospect sees
// before handing off to the Google Calendar booking page. Every landing CTA
// links here. See PRD/PRD_DiscoverySession.md (C3, C6, C9).
import { Link } from "react-router-dom";
import { Wordmark } from "./Wordmark";
import Icon from "./icons/Icon";
import iconLight from "../assets/brand/sahod-icon-light.svg";
import { DISCOVERY_BOOKING_URL } from "../config/discovery";
// Also loaded via LandingPage; imported here so this page declares its own dependency.
import "../styles/sections/landing.css";

const EXPECT_ITEMS = [
  "30 minutes on Google Meet",
  "You talk, we listen — no slides, no pitch",
  "An honest answer on whether Sahod fits. If it does, we'll send you a link to set up your company.",
];

export function DiscoveryPage() {
  return (
    <div className="landing">
      {/* Header deliberately avoids .nav__links/.nav__actions/.nav__toggle — those hide
          up to 1000px and this page has no menu to bring Log In back (C14). */}
      <nav className="nav">
        <div className="lp-container nav__inner">
          <Link to="/" className="brand">
            <img className="brand__logo" src={iconLight} alt="" />
            <Wordmark />
          </Link>
          <Link to="/login" className="lp-btn lp-btn--outline">Log In</Link>
        </div>
      </nav>

      <section className="lp-section">
        <div className="lp-container discovery-body">
          <div className="discovery-rule" />
          <h1>Let's understand your payroll first</h1>
          <ul className="checklist">
            {EXPECT_ITEMS.map((item) => (
              <li key={item}><span className="ck" aria-hidden="true"><Icon name="check" size={13} /></span> {item}</li>
            ))}
          </ul>
          <p className="discovery-note">Times are shown in your local time.</p>
          <div className="discovery-actions">
            <a
              href={DISCOVERY_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="lp-btn lp-btn--primary lp-btn--lg"
            >
              Choose a time
            </a>
            <Link to="/" className="discovery-back">Back to home</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
